/** Where home opens (R4, R9, KTD2, KTD4). Pure: the caller loads the plans, `myWeek`, and `dayItems`. */

/** A plan as the list returns it, last opened first. */
export interface HomePlan {
  id: string;
  built: boolean;
}

export type Home<P extends HomePlan> = { kind: 'my_week' } | { kind: 'plan'; plan: P } | { kind: 'list' };

/**
 * Whether My week is offered (R9, R10, KTD2): `myWeek` on and one built plan with day items on,
 * or two with them off, as before the planbook.
 */
export const hasMyWeek = (builtCount: number, myWeek: boolean, dayItems: boolean): boolean => myWeek && builtCount >= (dayItems ? 1 : 2);

/**
 * Whether the planbook is the place to plan: My week on with day items on. Then a plan's week is
 * the planbook's, and its own weekly view is retired; with either off, nothing changes.
 */
export const planbookOn = (myWeek: boolean, dayItems: boolean): boolean => myWeek && dayItems;

/** My week when `hasMyWeek`, else the last-opened plan, else the list. */
export function homeFor<P extends HomePlan>(plans: readonly P[], myWeek: boolean, dayItems: boolean): Home<P> {
  if (hasMyWeek(plans.filter(p => p.built).length, myWeek, dayItems)) return { kind: 'my_week' };
  return plans[0] ? { kind: 'plan', plan: plans[0] } : { kind: 'list' };
}
